<script>
import {updateMontant} from '../../mixins/updateMontant.js';

export default {
  name: 'PhaseRentab',
  props: [
    'name',
    'phase',
    '_id',
    'honos',
    'factured',
    'depenses',
    'err',
    'alphaFactured', //Le coefficient pour convertir le montant en euro en une largeur de barre sur le graphique (en pourcentage) - Honos * alpha = % de large pour le côté vert (positif)
    'alphaHonos',
    'tthonos',
    'ttfactured',
    'scaleMultiplayer'
  ],
  mixins:[updateMontant],
  computed:{
    styleGray(){
      return {'width':((this.factured / this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'}
    },
    styleGreen(){
      return {'width': (((this.factured-this.depenses)/this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'}
    },
    styleGreenBis(){
      return {'width': (((this.honos-this.depenses)/this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'}
    },
    styleRedBis(){
      return {'width': (((this.depenses - this.factured) / this.tthonos) * 100)*(1+(this.scaleMultiplayer/100))+ '%'} // % selon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },
    styleRed(){
      return {'width': (((this.depenses - this.factured) / this.tthonos) * 100)*(1+(this.scaleMultiplayer/100))+ '%'} // % selon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },
    styleBlue(){
      return {'width':((this.honos / this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'} // % celon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },

    styleLabelGray(){
      return {'left':((this.factured / this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'}
    },

    styleLabelRed(){
      return {'right': (((this.depenses - this.factured) / this.tthonos) * 100)*(1+(this.scaleMultiplayer/100))+ '%'} // % celon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },
    styleLabelBlue(){
      return {'left':((this.honos / this.tthonos)*100)*(1+(this.scaleMultiplayer/100))+ '%'} // % celon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },
    styleAxeRed(){
      return {'left': (((this.depenses - this.factured) / this.tthonos) * 100)*(1+(this.scaleMultiplayer/100))+ '%'} // % celon le tt des honoraires x 1.5 pour ameliorer la visibilité 
    },
  }
}
</script>


<template>
  <div class="card">
    <figure  v-on:click="$emit('clicked-link')">
      <slot name="figure">
        <img src="../../assets/projetIcon.png">
      </slot>
    </figure>
    <header  v-on:click="$emit('clicked-link')">
      <slot name="header">
        <div class="title"> {{name}} </div>
        <div class="subTitle"> {{phase}} </div>
      </slot>
    </header>
    <body>
      <slot name="body">
        <div class="body-jours">
          <!-- TODO : (Honos - dépenses) / (salaire moyen * coeff) -->
          <!-- (Salaire moyen * coeff) à calculer dans la page parent et à passer à ce composant enfant en prop -->
          <!-- Voir à faire depuis le serveur... -->
        </div>
        <div v-if="err.length" class="err">Pas de valeur saisie pour le coefficient '{{err[0].name}}' ( <span v-for="item in err" :key="item.annee"> {{item.annee}} </span> )</div>
        <div v-else class="body-graph">
          <div class="body-graph-axe"></div>
          <div class="body-graph-axe2"></div>

          <div class="body-graph-bar body-graph-green" v-bind:style="styleGreen" v-if="(depenses <= factured)"></div>
          <div class="body-graph-bar body-graph-red" v-bind:style="styleRed" v-else></div>
          <div class="body-graph-bar body-graph-gray" v-bind:style="styleGray"></div>

          <div class="body-graph-labelBlue" v-bind:style="styleLabelBlue">Contrat : {{updateMontant(honos).str}} € </div>
          <div class="body-graph-labelGray" v-bind:style="styleLabelGray">Facturées : {{updateMontant(factured).str}} €</div>
          <div class="body-graph-labelGreen" v-if="(depenses <= factured)">Résultat: + {{updateMontant(factured-depenses).str}} € </div>
          <div class="body-graph-labelRed" v-bind:style="styleLabelRed" v-else> Résultat: - {{updateMontant(depenses-factured).str}} € </div>
          <div class="body-graph-labelGraphite" v-bind:style="styleLabelGreen" v-if="(depenses <= honos)"> Projection net: {{updateMontant(honos-depenses).str}} € </div>
          <div class="body-graph-labelRedBis" v-bind:style="styleLabelRed" v-else> Projection net: {{updateMontant(honos-depenses).str}} € </div>

          <div class="body-graph-axe"></div>
          <div class="body-graph-bar annexe-graph-green" v-bind:style="styleGreenBis" v-if="(honos-depenses >0)"><div class="body-graph-axe"></div></div>
          <div class="body-graph-bar annexe-graph-red" v-else v-bind:style="styleRed" ></div>
          <div class="body-graph-bar annexe-graph-blue" v-bind:style="styleBlue"></div>
        </div>
      </slot>
    </body>
    <footer>
      <slot name="footer">
        <div v-if="!err.length" class="footer">
          <!-- <div v-bind:class="{ 'footer-negative': ((depenses - honos) > 0) }">{{updateMontant(honos - depenses).str}} €</div> -->
        </div>
      </slot>
    </footer>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.card{
  @include myBlock;
  @include myFont;
  display: flex;
  padding: 0;
  height: 50px;
  overflow: hidden;
  margin: 0 0 6px 0;

  & figure{
    margin: 0 10px 0 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    width: 100px;

    & img{
      height: 100%;
    }
  }

  & header{
    width: 200px;
    overflow: hidden;
    cursor: pointer;

    & .title{
      @include myFont;
      @include monoline;
      font-weight: 600;
      color: $main;
      margin: 7px 0 2px 0;
    }

    & .subTitle{
      @include myFont;
      @include monoline;
      color: $black-bolder;
      font-size: 12px;
      height: 17px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  & body{
    flex: 1;
    padding: 0 0px 0 0px;
    margin: 0 0 0px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  & footer{
    width: 130px; //Valeur nécessaire pour absorber le labelGray des honoraires pour la phase qui a les plus grand honoraires.
    // display: flex;
    // flex-direction: column;
    // align-items: flex-end;
    // justify-content: center;
  }

}

.body{
  &-jours{
    font-size: 13px;
  }

  &-graph{
    font-size: 13px;
    flex: 1;
    margin: 0 10px 0 70px;
    display: grid;
    grid-template-columns: 30% 70%; //Si je modifie les proportions, penser à les changer également dans methods/styleRed()
    // overflow: hidden;

    &-axe{
      border-style: solid;
      border-color: $black-bold;
      border-width: 0 0 0 1px;
      height: 20px;
      grid-column: 2;
      grid-row: 2;
      z-index: 50;
    }
    &-axe2{
      border-style: solid;
      border-color: $black-bold;
      border-width: 0 0 0 1px;
      height: 20px;
      grid-column: 2;
      grid-row: 1;
      z-index: 50;
    }
    &-bar{
      height: 5px;
      align-self: center;
    }
    &-red{
      background-color: $alert;
      grid-column: 1;
      grid-row: 2;
      justify-self: end;
      border-radius: 5px 0 0 5px;
    }
    &-green{
      background-color: $green;
      grid-column: 2;
      grid-row: 2;
      z-index: 10;
      border-radius: 0 5px 5px 0;
    }

    &-gray{
      background-color: $black-light;
      grid-column: 2;
      grid-row: 2;
      border-radius: 0 5px 5px 0;
    }

    &-labelGray{
      font-size: 12px;
      color: $black;
      grid-column: 2;
      grid-row: 2;
      position: relative;
      bottom: 2px;
      padding: 0 0 0 7px;
      white-space: nowrap;
    }
    &-labelGreen{
      font-size: 12px;
      color: $green;
      grid-column: 1;
      grid-row: 2;
      padding: 0 5px 0 0;
      justify-self: end;
      white-space: nowrap;
      position: relative;
      text-align: center;

    }
    &-labelBlue{
      font-size: 12px;
      color: #45494E;
      grid-column: 2;
      grid-row: 1;
      position: relative;
      bottom: 2px;
      padding: 0 0 0 7px;
      white-space: nowrap;
    }
    &-labelRed{
      font-size: 12px;
      color: $alert;
      grid-column: 1;
      grid-row: 2;
      justify-self: end;
      position: relative;
      bottom: 1px;
      padding: 0 7px 0 0;
      text-align: center;
      white-space: nowrap;
    }
    &-labelRedBis{
      font-size: 12px;
      color: $alert;
      grid-column: 1;
      grid-row: 1;
      justify-self: end;
      position: relative;
      bottom: 1px;
      padding: 0 7px 0 0;
      text-align: center;
      white-space: nowrap;
    }
    &-labelGraphite{
      font-size: 12px;
      color: #45494E;
      grid-column: 1;
      grid-row: 1;
      justify-self: end;
      position: relative;
      bottom: 1px;
      padding: 0 7px 0 0;
      text-align: center;
      white-space: nowrap;
    }
  }
}

.annexe{
  &-graph{
    font-size: 13px;
    flex: 1;
    margin: 0 10px 0 70px;
    display: grid;
    grid-template-columns: 30% 70%; //Si je modifie les proportions, penser à les changer également dans methods/styleRed()
    // overflow: hidden;
  
      &-green{
      background-color: $green;
      grid-column: 2;
      grid-row: 1;
      z-index: 3;
      border-radius: 0 5px 5px 0;
    }
    &-blue{
      background-color: #45494E;
      grid-column: 2;
      grid-row: 1;
      border-radius: 0 5px 5px 0;
    }
    &-gray{
      background-color: $black-light;
      grid-column: 2;
      grid-row: 1;
      z-index: 2;
      border-radius: 0 5px 5px 0;
    }
    &-red{
      background-color: $alert;
      grid-column: 1;
      grid-row: 1;
      justify-self: end;
      z-index: 3;
      border-radius: 5px 0 0 5px;
    }
    &-labelGray{
      font-size: 12px;
      color: $black;
      grid-column: 2;
      grid-row: 2;
      position: relative;
      bottom: 2px;
      padding: 0 0 0 7px;
      white-space: nowrap;
    }
    &-labelGreen{
      font-size: 12px;
      color: $green;
      grid-column: 1;
      grid-row: 3;
      bottom: 2px;
      padding: 0 0 0 7px;
      white-space: nowrap;
      position: relative;
      
    }
    &-labelBlue{
      font-size: 12px;
      color: #45494E;
      grid-column: 2;
      grid-row: 1;
      position: relative;
      bottom: 2px;
      padding: 0 0 0 7px;
      white-space: nowrap;
    }
  }
}

.err{
  color: $black;
  font-size: 13px;
}

</style>
